

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./SuccessModal.css";

const SuccessModal = ({ show, onClose,message}) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="success-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="success-modal"
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.7, opacity: 0 }}
            transition={{ type: "spring", stiffness: 120 }}
            onClick={(e) => e.stopPropagation()}
          >
            <motion.div
              className="success-check"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2 }}
            >
              ✅
            </motion.div>

            <h2>Submitted Successfully!</h2>
            <p>{message}</p>

            <button className="success-close-btn" onClick={onClose}>
              Close
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SuccessModal;
